import { render, staticRenderFns } from "./EmailCampaign.vue?vue&type=template&id=14228337&scoped=true"
import script from "./EmailCampaign.vue?vue&type=script&lang=js"
export * from "./EmailCampaign.vue?vue&type=script&lang=js"
import style0 from "./EmailCampaign.vue?vue&type=style&index=0&id=14228337&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14228337",
  null
  
)

export default component.exports